export default __webpack_public_path__ + "static/scara_webapp-264dedf959c6ddf3eea047f113090bd1.png";